import m from "react";
import { cls as n } from "../../../helpers/cls.js";
import { withDisplay as p } from "../../../helpers/display.js";
import { spacingReplace as t } from "../../../helpers/spacingReplace.js";
var i = Object.defineProperty,
  c = Object.defineProperties,
  s = Object.getOwnPropertyDescriptors,
  a = Object.getOwnPropertySymbols,
  f = Object.prototype.hasOwnProperty,
  b = Object.prototype.propertyIsEnumerable,
  l = (r, e, o) => e in r ? i(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : r[e] = o,
  d = (r, e) => {
    for (var o in e || (e = {})) f.call(e, o) && l(r, o, e[o]);
    if (a) for (var o of a(e)) b.call(e, o) && l(r, o, e[o]);
    return r;
  },
  g = (r, e) => c(r, s(e));
const y = r => m.createElement("div", g(d({
  "data-ds-component": "DS-TextInput"
}, r.width && {
  style: {
    width: r.width
  }
}), {
  className: n("olx-text-input", r.className, t("olx-m", r.margin), t("olx-ml", r.marginLeft), t("olx-mb", r.marginBottom), t("olx-mt", r.marginTop), t("olx-mr", r.marginRight), p(r.display))
}), r.children);
export { y as Container };